import { z } from 'zod';
/**
 * Os contratos da operação: a saúde detalhada, o painel de jobs e os
 * contadores por rota (documento 20).
 *
 * Nada aqui é tela de arena. O que estes contratos descrevem é do
 * PROCESSO e da FILA — de todas as arenas juntas —, e por isso nenhuma
 * destas rotas passa pela sessão de arena: quem lê é o operador do
 * sistema, com a credencial própria (`Authorization: Operador …`). Um
 * Dono de arena que enxergasse a fila morta enxergaria os jobs mortos
 * das OUTRAS arenas.
 *
 * Os números de rota são da RÉPLICA que respondeu — cada processo conta
 * o próprio tráfego, em memória. `processo.hostname` diz qual.
 *
 * Ver: Arena_backend/Docs/plano/20-observabilidade-hardening.md
 */
/** Uma hora: o que os contadores por rota guardam em memória. */
export const JANELA_MAXIMA_DE_ROTAS_MINUTOS = 60;
/**
 * Sete dias: a retenção dos jobs concluídos no pg-boss (documento 07).
 * Uma janela maior que isso contaria menos do que aconteceu, calada.
 */
export const JANELA_MAXIMA_DE_JOBS_HORAS = 7 * 24;
export const zConsultaDeRotas = z.object({
    minutos: z.coerce.number().int().min(1).max(JANELA_MAXIMA_DE_ROTAS_MINUTOS).default(15),
});
export const zConsultaDePainelDeJobs = z.object({
    horas: z.coerce.number().int().min(1).max(JANELA_MAXIMA_DE_JOBS_HORAS).default(24),
});
//# sourceMappingURL=operacao.js.map